<template>
  <o-view>
    <o-nav-bar
      title="Cambio"
      :has-back-button="true"
      :has-close-button="true"
      :is-overlay="true"
    />
    <o-section :is-transparent="true">
      <p>
        We kunnen maar deels aan je reservatievraag voldoen. Hieronder een greep
        uit de lijst van mogelijke alternatieven die we je kunnen aanbieden.
      </p>
    </o-section>
    <o-block-list title="Onze voorstellen" :padding="false">
      <template v-slot:actions>
        <a href="#" @click.prevent="showOverlay('filters')">
          <o-icon icon="filter" />
        </a>
      </template>
      <template v-slot:default>
        <o-cambio-reservation
          v-for="reservation in reservations"
          :key="reservation.label"
          :label="reservation.label"
          :label-changed="reservation.labelChanged || false"
          :label-original="reservation.labelOriginal || null"
          :type="reservation.type || null"
          :type-changed="reservation.typeChanged || false"
          :type-original="reservation.typeOriginal || null"
          :date="reservation.date || null"
          :date-changed="reservation.dateChanged || false"
          :date-original="reservation.dateOriginal || null"
          link="/sales/car/cambio/reservations/edit-summary"
        />
      </template>
    </o-block-list>
    <o-overlay ref="filters" title="Filter zoekresultaten">
      <template #form>
        <o-section :overlay="true">
          <p>Kies hieronder welke zoekresultaten je wenst te zien.</p>
          <o-checkbox name="klasse">Toon enkel gewenste wagenklasse</o-checkbox>
          <o-checkbox name="periode">Toon enkel gewenste periode</o-checkbox>
          <o-checkbox name="standplaats">
            Toon enkel gewenste standplaats
          </o-checkbox>
        </o-section>
      </template>
      <o-button :is-primary="true" label="Bevestig" />
    </o-overlay>
  </o-view>
</template>

<script>
import OCambioReservation from '@/components/OCambioReservation.vue'
import OOverlay from '@/components/base/OOverlay.vue'
import OCheckbox from '@/components/base/OCheckbox.vue'
import OButton from '@/components/base/OButton.vue'

export default {
  name: 'CambioEdit',
  components: {
    OButton,
    OCheckbox,
    OOverlay,
    OCambioReservation
  },
  data() {
    return {
      reservations: [
        {
          label: 'Gent - Gent-Dampoort',
          type: 'Berline M',
          date: '26/06/2019    11:00 - 17:00',
          dateChanged: true,
          dateOriginal: '10:00 - 17:00'
        },
        {
          label: 'Spaanskasteel',
          labelChanged: true,
          labelOriginal: 'Gent-Dampoort',
          type: 'Berline M',
          date: '28/05/2019    15:00 - 17:00'
        },
        {
          label: 'Brussel - Kunstberg',
          type: 'Berline M',
          typeChanged: true,
          typeOriginal: 'Micra S',
          date: '15/05/2019    10:00 - 11:00'
        }
      ]
    }
  }
}
</script>
